import { z } from 'zod';
import { ProposalContent, customerProposalContent } from './customer-proposal.js';
import { CustomerPricing } from './customer-pricing.js';
/** Private API-to-renderer input. Never embed this input in the browser: it contains staff data. */
export const ProposalDraftRenderInput = z.object({
    id: z.string().uuid(), version: z.number().int().positive(), updated_at: z.string().datetime({ offset: true }),
    source_sha256: z.string().regex(/^[a-f0-9]{64}$/), content: ProposalContent,
    pricing: CustomerPricing.nullable(), blockers: z.array(z.string().max(2000)).max(200),
}).strict();
/** The same explicit customer whitelist used by publication, without publishing. */
export function proposalDraftCustomerCopy(input) {
    const value = ProposalDraftRenderInput.parse(input);
    return { id: value.id, version: value.version, updated_at: value.updated_at, source_sha256: value.source_sha256,
        document: customerProposalContent(value.content, value.pricing), blockers: value.blockers };
}
//# sourceMappingURL=proposal-draft-preview.js.map